import { createAsyncThunk } from '@reduxjs/toolkit';
import lodash from 'lodash';
import Logger from '../utils/Logger';
import Api, { AuthenticationMethod, FetchParams } from '../utils/Api';
import { FAILURE_REASON } from '../constants';

export const validateGiftCardTopUpSale = createAsyncThunk(
  '$validateGiftCardTopUpSale',
  async (
    data: {
      uuid: string;
      route: 'giftcard' | 'topup';
      giftCardTopUpBody: PaymentPacket;
      authenticationMethod?: AuthenticationMethod;
    },
    { getState: _, rejectWithValue },
  ) => {
    const {
      uuid,
      route,
      giftCardTopUpBody,
      authenticationMethod = 'trusted',
    } = data;

    let response;
    let valid = false;
    let reason;
    let errorText: string = '';

    try {
      if (!uuid) {
        throw new Error('Cannot validate gift card / topup sale without uuid');
      }

      const validateGiftCardTopUpApiPathMapper = {
        giftcard: '/api/v1/sale/giftcard/token_validate_cart',
        topup: '/api/v1/sale/topup/token_validate_cart',
      };

      const saleAmount =
        giftCardTopUpBody?.OrderTotal ||
        giftCardTopUpBody?.GCTopupAmount ||
        giftCardTopUpBody?.HCTopupAmount;
      if (!saleAmount || saleAmount <= 0) {
        throw new Error('Order Total Amount should be greater than 0.');
      }

      Logger.log(
        `validating ${route}:`,
        undefined,
        JSON.stringify(giftCardTopUpBody),
      );
      Logger.log(JSON.stringify(giftCardTopUpBody, null, 2));

      const params: FetchParams = {
        path: validateGiftCardTopUpApiPathMapper[route],
        method: 'POST',
        body: giftCardTopUpBody,
        applicationErrorAllowed: true,
      };

      response = await Api.fetch(params, authenticationMethod);

      Logger.log('Validation response:', undefined, response);
      valid = response.success;

      // process validation error
      if (!valid) {
        reason = FAILURE_REASON.UNKNOWN;
        errorText = lodash.get(response, 'error', '');

        let extraInfo = lodash.get(response, 'extra_info');
        //@ts-ignore
        extraInfo = Array.isArray(extraInfo) ? extraInfo : [];

        let firstValidationMsg;

        try {
          //@ts-ignore
          firstValidationMsg = extraInfo
            //@ts-ignore
            .map(
              (err?: { msg?: string }) =>
                lodash.get(err, 'msg', '').trim() || undefined,
            )
            .filter((msg?: string) => Boolean(msg))[0];
        } catch {
          Logger.log('problem parsing extra info');
        }

        if (firstValidationMsg) {
          errorText += `: ${firstValidationMsg}`;
        }
      }

      return {
        valid,
        reason,
        errorText,
      };
    } catch (e) {
      console.error(`Validate ${route} pay failed`, e);
      return rejectWithValue({
        e,
        reason:
          (lodash.get(e, 'details.type', '') as string) === 'connectivity'
            ? FAILURE_REASON.FETCH_FAILED
            : undefined,
        errorText,
      });
    }
  },
);
